import React, { useState } from "react";

import { useFeatureFlag, useTranslation } from "utils";

import { FEATURE_FLAGS } from "consts";

import { Flex, Tag, Typography } from "components";

import { DocumentScanOverlay } from "pages/app/document-scan/DocumentScanOverlay";
import { ImportCropDataPromoCard } from "pages/app/document-scan/components/ImportCropDataPromoCard";

/**
 * Keeping the button, the promo card and the overlay together means one flag gate — the promo can
 * never advertise an entry point the flag has hidden — and one overlay instance for both triggers.
 */
export const ImportCropsButton = () => {
  const { t } = useTranslation("docScans");
  const [showOverlay, setShowOverlay] = useState(false);

  const { isEnabled: isDocScanEnabled } = useFeatureFlag(FEATURE_FLAGS.DOC_SCAN_FOR_FARMERS, {
    project: "common",
    defaultValue: { enabled: false },
    resolveEnabled: (value) => (typeof value === "object" && value !== null ? value.enabled === true : value === true),
  });

  if (!isDocScanEnabled) return null;

  const open = () => setShowOverlay(true);

  return (
    <>
      <Flex
        className="import-crops-button"
        align="center"
        gap="0.5rem"
        role="button"
        tabIndex={0}
        aria-label={t("upload.overlayTitle")}
        data-testid="import-crops-button"
        onClick={open}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            open();
          }
        }}
      >
        <Tag colour="blue" text={t("upload.newBadge")} className="import-crops-button-badge" />
        <Typography variant="paragraph-m" bold noWrap className="margin-0">
          {t("upload.overlayTitle")}
        </Typography>
      </Flex>
      <ImportCropDataPromoCard onTryItOut={open} />
      <DocumentScanOverlay showOverlay={showOverlay} onClose={() => setShowOverlay(false)} />
    </>
  );
};
